import * as Types from './Types'
import DB from '../database/offlineDB.json'

export function setOfflineSetup() {
  return dispatch => {
    dispatch({
      type: Types.INIT_OFFLINE_MODE
    })
  }
}

export function tryGetBookingSystemOffline(id) {
  return dispatch => {
    dispatch({
      type: Types.GET_BOOKING_SYSTEM_SUCCESS,
      payload: DB.bookingSystems[id]
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/OfflineMode.js